import { finalCTATitle, finalCTASubtitle } from "@/mocks/content";

export default function FinalCTA() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-[1.2]">
          {finalCTATitle}
        </h2>
        <p className="text-base md:text-lg text-foreground-600 mb-10 leading-relaxed">
          {finalCTASubtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Start Exploring
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 border-2 border-primary-500 text-primary-500 rounded-full text-base font-semibold hover:bg-primary-500 hover:text-background-50 transition-all whitespace-nowrap cursor-pointer"
          >
            AllChinaBuy Sheet
            <i className="ri-external-link-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}